import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-player-exists-modal',
  templateUrl: './player-exists-modal.component.html',
  styleUrls: ['player-exists-modal.component.scss']
})
export class PlayerExistsModalComponent {
  @ViewChild('modal') public modal: ModalComponent;

  public constructor(private router: Router) { }

  public open(): void {
    this.modal.open();
  }

  public close(reason: string): void {
    this.modal.close(reason);
  }

  public onCloseClick(): void {
    this.close('close clicked');
  }

  public onContinueClick(): void {
    this.close('continue clicked');
    this.router.navigateByUrl('/min-side/mine-lodsedler?action=openshop');
  }
}
